import React, { useState } from "react";
import axios from "axios";
import "./Loginn.css";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const VERIFY_OTP_API =
    "https://devskillz-ifm6.onrender.com/api/forgot-password/verify-otp";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");
    setError("");

    try {
      const res = await axios.post(VERIFY_OTP_API, {
        email,
        otp,
        newPassword,
      });

      setMessage(res.data.message || "Password reset successful.");
    } catch (err) {
      setError(
        err.response?.data?.error || "Invalid OTP or expired."
      );
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        <h2>Reset Password</h2>
        <p className="subtitle">
          Enter OTP and new password
        </p>

        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="Registered Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Enter OTP"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />

          <button type="submit">Reset Password</button>

          {message && <p style={{ color: "green" }}>{message}</p>}
          {error && <p className="error">{error}</p>}
        </form>
      </div>
    </div>
  );
}

export default ResetPassword;
